const buildRelease = true;

const Config = {
  debug: true, // buildRelease ? false : true,
  versionCode: 20220614,
  buildRelease,
  useServerTest: true
};
export default Config;
